"use client";

import { userIsCandidate } from "@nimble/datamodel/models/user";
import React from "react";

import { NonCandidateModalView } from "@/components/shared/auth-paywall/non-candidate-modal.view";
import useSignUpDrawer from "@/hooks/use-sign-up-drawer";
import routes from "@/lib/routes";
import { useAuth, useSignOut } from "@/stores/use-auth";

export function NonCandidateModalContainer() {
  const { user, isLoading } = useAuth();
  const { openDrawer } = useSignUpDrawer();
  const { signOut } = useSignOut();

  const handleCreateCandidateAccount = async () => {
    await signOut();
    openDrawer("1");
  };

  const adminDashboardHref = routes.getAtsAdminDashboard();

  if (isLoading || !user || userIsCandidate(user?.profile?.user_type)) {
    return null;
  }

  return (
    <NonCandidateModalView
      adminDashboardHref={adminDashboardHref}
      onCreateCandidateAccount={handleCreateCandidateAccount}
      onSignOut={signOut}
    />
  );
}
